const gaUa = 'UA-48553583-1';

window.dataLayer = window.dataLayer || [];

window.gtag = function() {
    window.dataLayer.push(arguments);
};

window.gtag('js', new Date());

let initialPagePath = window.location.pathname + window.location.hash;

window.gtag('config', gaUa, {
    'page_title': document.title,
    'page_location': window.location.href,
    'page_path': initialPagePath
});

window.addEventListener('hashchange', () => {
    const pagePath = window.location.pathname + window.location.hash;

    if (pagePath === initialPagePath) {
        initialPagePath = null;
        return;
    }

    window.gtag('event', 'page_view', {
        'send_to': gaUa,
        'page_title': document.title,
        'page_location': window.location.href,
        'page_path': pagePath,
    });
});



//////////////////
// WEBPACK FOOTER
// ./modules/googleTag.js
// module id = 26
// module chunks = 0